/* global jQuery, ga4Obj */

import { Module } from 'wrapper6'
import { handleOnClickSelectItemEvent } from './_ga4-tracking-select-item'
import { addViewItemListOnPageLoad, handleOnClickViewItemListEvent } from './_ga4-tracking-view-item-list'
import { handleAddShippingInfoEvent } from './_ga4-tracking-shipping-info'
import { handleAddPaymentInfoEvent } from './_ga4-tracking-payment-info'
import { addViewItemOnPageLoad } from './_ga4-tracking-view-item'
import { addViewCartOnPageLoad } from './_ga4-tracking-view-cart'
import { addBeginCheckoutOnPageLoad } from 'app/GA4/_ga4-tracking-begin-checkout'
import { addPurchaseOnPageLoad } from './_ga4-tracking-purchase'

export default class GA4TrackingHandler extends Module {
  ready () {
    jQuery(document).ready(() => {
      handleOnClickSelectItemEvent()
      handleOnClickViewItemListEvent()
      handleAddShippingInfoEvent()
      handleAddPaymentInfoEvent()
      addViewItemListOnPageLoad()
      addViewItemOnPageLoad()
      addViewCartOnPageLoad()
      addBeginCheckoutOnPageLoad()
      addPurchaseOnPageLoad()
    })
  }
}
